<p>
  user works!
</p>

<button (click)="register()">Register</button>



// WEBPACK FOOTER //
// ./src/app/user/user.component.html